module.exports = __webpack_public_path__ + "img/title-03-1(pocket).d9878bc1.png";